import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js/instance/includes';
import { css, on, preventEvent, off } from './utils.js';

var Draggable = /*#__PURE__*/function () {
  function Draggable(onDragMove, onDragEnd) {
    var _this = this;

    _classCallCheck(this, Draggable);

    _defineProperty(this, "dragEnd", function () {
      off(window, 'mousemove touchmove', _this.onDragMove);
      off(window, 'mouseup touchend touchcancel', _this.onDragEnd);
      css(document.body, 'user-select', '');
      _this.dragging = false;
    });

    this.onDragMove = onDragMove;
    this.onDragEnd = onDragEnd;
    this.dragging = false;
  }

  _createClass(Draggable, [{
    key: "getEventPos",
    value: function getEventPos(e) {
      var _context;

      var left = e.clientX,
          top = e.clientY;

      if (e.type && _includesInstanceProperty(_context = e.type).call(_context, 'touch')) {
        var _context2;

        // for touch events
        var ev = e.originalEvent || e;
        var touches0;

        if (_includesInstanceProperty(_context2 = ['touchstart', 'touchmove']).call(_context2, e.type)) {
          touches0 = ev.touches[0];
        } else {
          // touchend or touchcancel
          touches0 = ev.changedTouches[0];
        }

        left = touches0.clientX;
        top = touches0.clientY;
      }

      return {
        top: top,
        left: left
      };
    }
  }, {
    key: "startDrag",
    value: function startDrag() {
      if (this.dragging) {
        return;
      }

      this.dragging = true;
      css(document.body, 'user-select', 'none');
      on(window, 'mousemove touchmove', this.onDragMove);
      on(window, 'mouseup touchend touchcancel', this.onDragEnd);
    }
  }], [{
    key: "preventDragScrolling",
    value: function preventDragScrolling() {
      css(document.body, 'overflow-y', 'hidden');
      window.addEventListener('touchstart', preventEvent, {
        passive: false
      });
    }
  }, {
    key: "enableDragScrolling",
    value: function enableDragScrolling() {
      css(document.body, 'overflow-y', '');
      window.removeEventListener('touchstart', preventEvent);
    }
  }]);

  return Draggable;
}();

export { Draggable };
